import { render } from "./GavLocationsDrag.vue?vue&type=template&id=5891c3ac&ts=true"
import script from "./GavLocationsDrag.vue?vue&type=script&lang=ts"
export * from "./GavLocationsDrag.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__